var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row whiteBG-wrap login-white-wrap"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap"
  }, [_c('router-link', {
    attrs: {
      "to": "/verify-identity"
    }
  }, [_c('h6', {
    staticClass: "login-highlight"
  }, [_vm._v("Back")])]), _vm._m(0), _vm._m(1), _c('div', {
    staticClass: "auth-form pt-1 pb-3"
  }, [_c('form', {}, [_c('div', [_vm._m(2), _c('div', {
    staticClass: "opt-num-wrap"
  }, [_c('v-otp-input', {
    ref: "otpInput",
    attrs: {
      "input-classes": _vm.errorClass + ' otp-input',
      "separator": "-",
      "num-inputs": 6,
      "should-auto-focus": true,
      "is-input-num": true,
      "input-type": "text"
    },
    on: {
      "on-complete": _vm.onChangeOTP,
      "on-change": _vm.handleOnChange
    }
  })], 1)]), _vm.otpErrorFlag ? _c('div', {
    staticClass: "valid-error mt-2"
  }, [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]) : _vm._e()]), _c('button', {
    staticClass: "submit-btn mt-3 next-btn ml-0",
    attrs: {
      "type": "button",
      "disabled": _vm.otp.length !== 6 || _vm.formLoader
    },
    on: {
      "click": _vm.verifyToken
    }
  }, [_vm.formLoader ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Verify OTP ")], 1), _c('login-otp', {
    attrs: {
      "expirySecond": 60,
      "setSpinnerLoader": _vm.otpLoader
    },
    on: {
      "sendOTP": _vm.sendOTP
    }
  })], 1), _c('div')], 1)]), _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding"
  }, [_c('login-in-carsoule')], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "left-login"
  }, [_c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/member-login.svg"),
      "alt": "image-fluid"
    }
  })])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h4', {
    staticClass: "login-title mb-2"
  }, [_vm._v("Verify OTP")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {}, [_c('label', {
    staticClass: "opt-label mt-0"
  }, [_vm._v("Enter OTP"), _c('span', {
    staticClass: "required-label"
  }, [_vm._v(" *")])])])]);
}]

export { render, staticRenderFns }